export default [
  {
    comicNumber: 1,
    date: "2021-01-29",
    comicTitle: "For Fun",
    titleText: `"Oh, and I make this webcomic called Brixie...hey, where are you going?"`,
  },
  {
    comicNumber: 2,
    date: "2021-02-01",
    comicTitle: "Mystery Text",
    titleText: `You people and your "having multiple friends" and "actually reaching out to them."`,
  },
  {
    comicNumber: 3,
    date: "2021-02-03",
    comicTitle: "Diet and Exercise",
    titleText: "Maybe beer and pizza will make me feel better.",
  },
  {
    comicNumber: 4,
    date: "2021-02-05",
    comicTitle: "Ready to Go",
    titleText: `"Sorry I'm early, Waze found me a faster route."`,
  },
  {
    comicNumber: 5,
    date: "2021-02-12",
    comicTitle: "You Can Do This",
    titleText: `"Oh dear god, they responded!"`,
  },
  {
    comicNumber: 6,
    date: "2021-02-19",
    comicTitle: "Contactless Delivery",
    titleText:
      "One great thing about Pandemic World is that I can get food without ever interacting with another human being.",
  },
  {
    comicNumber: 7,
    date: "2021-02-26",
    comicTitle: "Heated Seats",
    titleText: `On this week's episode of "Person Who Isn't Used to Having Nice Things":`,
  },
  {
    comicNumber: 8,
    date: "2021-03-05",
    comicTitle: "Time Cook",
    titleText: "Lord help me if someone leaves time on the microwave.",
  },
  {
    comicNumber: 9,
    date: "2021-03-12",
    comicTitle: "Important Tasks",
    titleText: `I sent this to my wife and she asked "Is that what you're doing right now?"`,
  },
  {
    comicNumber: 10,
    date: "2021-03-19",
    comicTitle: "Relatable",
    titleText: "*looks to the window and sees Catana Chetwynd peeking in*",
  },
  {
    comicNumber: 11,
    date: "2021-03-26",
    comicTitle: "Bother",
    titleText: `"What about Stop, Drop, and Roll?" "Eh, sounds like too much effort."`,
  },
  {
    comicNumber: 12,
    date: "2021-04-01",
    comicTitle: "awkward lego man (April Fools)",
    titleText: "April Fools!",
    className: "aprilFools",
  },
  {
    comicNumber: 13,
    date: "2021-04-09",
    comicTitle: "Free Trial",
    titleText:
      "This was bad enough before COVID. I'm not looking forward to readjusting to socialization.",
  },
  {
    comicNumber: 14,
    date: "2021-04-16",
    comicTitle: "Patient",
    titleText:
      "This does nothing to disprove my belief that I am actually just a cat.",
  },
  {
    comicNumber: 15,
    date: "2021-04-23",
    comicTitle: "Adult",
    titleText:
      "Next you're gonna tell me it's been 10 years since I graduated college. ... OH GOD!",
  },
  {
    comicNumber: 16,
    date: "2021-04-30",
    comicTitle: "Motivation",
    titleText:
      "I definitely didn't build a 4000 piece LEGO roller coaster instead of doing what I was supposed to this week",
  },
  {
    comicNumber: 17,
    date: "2021-05-07",
    comicTitle: "Pacing",
    titleText:
      "You mean I get to practice imaginary conversations I'll never have *AND* I'm improving my health?",
  },
  {
    comicNumber: 18,
    date: "2021-05-14",
    comicTitle: "Car Horn",
    titleText: "Hondas from the 2000s had such wussy horns.",
  },
  {
    comicNumber: 19,
    date: "2021-05-21",
    comicTitle: "Easy",
    titleText:
      "We both spent the first year of our relationship just waiting for the other shoe to drop. Turns out relationships can just be easy.",
  },
  {
    comicNumber: 20,
    date: "2021-05-28",
    comicTitle: "Old Posts",
    titleText:
      "Our parents were just as dumb as us. Their stupidity just wasn't archived.",
  },
  {
    comicNumber: 21,
    date: "2021-06-04",
    comicTitle: "Kitty Sense",
    titleText: "Sorry I'm late I had a ca- uh, traffic.",
  },
  {
    comicNumber: 22,
    date: "2021-06-11",
    comicTitle: "Creative Process",
    titleText: "Oh god, why did I start this stupid webcomic?",
  },
  {
    comicNumber: 23,
    date: "2021-06-18",
    comicTitle: "Actually Cook",
    titleText: `2 weeks later: "Aw man, the ingredients I bought all went bad."`,
  },
  {
    comicNumber: 24,
    date: "2021-06-25",
    comicTitle: "Other People",
    titleText:
      "Yep, this was definitely a thing restricted to high school. Hasn't carried over into my adult life at all.",
  },
  {
    comicNumber: 25,
    date: "2021-07-02",
    comicTitle: "Vacation",
    titleText:
      "My actual vacation is going to be to Colorado, but my attire for that doesn't lend itself as well to the visual shorthand of going to the beach.",
  },
  {
    comicNumber: 26,
    date: "2021-07-23",
    comicTitle: "Scam Likely",
    titleText:
      "I like to imagine Scam Likely as an actual person who cold calls people and tries to steal their money. Also he has a thin handlebar mustache.",
  },
  {
    comicNumber: 27,
    date: "2021-07-30",
    comicTitle: "Mechanic",
    titleText: `"You're also dangerously low on blinker fluid." "Oh no, is that expensive?`,
  },
  {
    comicNumber: 28,
    date: "2021-08-06",
    comicTitle: "Tried Harder",
    titleText: "Also known as gifted kid syndrome.",
  },
  {
    comicNumber: 29,
    date: "2021-08-13",
    comicTitle: "Job Hunt",
    titleText:
      "Before you mention the current understaffing crisis, I'm in my 30s and have a college degree, so I ain't working retail or food service.",
  },
  {
    comicNumber: 30,
    date: "2021-08-27",
    comicTitle: "Doing Okay",
    titleText:
      "I generally send my wife these comics for notes becuase she's good at comedy, but there have been times that they have made her generally concerned for my wellbeing.",
  },
  {
    comicNumber: 31,
    date: "2021-09-03",
    comicTitle: "Horse Medicine",
    titleText:
      "I still haven't decided whether the centaur is offended or complimented.",
  },
  {
    comicNumber: 32,
    date: "2021-09-10",
    comicTitle: "Right Place",
    titleText:
      "I accidentally walked into the wrong house one time several years ago, and I don't think I've ever fully recovered from that.",
  },
  {
    comicNumber: 33,
    date: "2021-09-24",
    comicTitle: "Two Weeks",
    titleText:
      "To be fair, we weren't expecting the closing date for our house to be the same weeks as our wedding.",
  },
  {
    comicNumber: 34,
    date: "2021-10-01",
    comicTitle: "Meditate",
    titleText:
      "Ain't it grand when you have to turn your mind of for 10 minutes just to get to a base level where you can function as a human being?",
  },
  {
    comicNumber: 35,
    date: "2021-10-08",
    comicTitle: "October",
    titleText:
      "Can't wait for the one week of nice weather before it's suddenly freezing.",
  },
  {
    comicNumber: 36,
    date: "2021-10-15",
    comicTitle: "Marriage",
    titleText:
      "Or maybe this is just a thing that happens when you get married in the middle of a global pandemic?",
  },
  {
    comicNumber: 37,
    date: "2021-10-22",
    comicTitle: "Intake",
    titleText: `"And then finally we'll need you to listen to your mom on the phone with your aunt while she incorrectly explains what's going on in your life"`,
  },
  {
    comicNumber: 38,
    date: "2021-10-29",
    comicTitle: "Haunted House",
    titleText:
      "There is truly nothing scarier than the constant linear flow of time.",
  },
  {
    comicNumber: 39,
    date: "2021-11-05",
    comicTitle: "HEY!",
    titleText: "Sorry, I didn't have a Rescue Helicopter to build.",
  },
  {
    comicNumber: 40,
    date: "2021-11-12",
    comicTitle: "Change",
    titleText:
      "God grant be the anxiety to complain about the things I cannot change, the laziness to complain about the the things I can, and the depression to wonder why nothing gets better.",
  },
  {
    comicNumber: 41,
    date: "2021-11-19",
    comicTitle: "Chocolate",
    titleText: "Plot twist: the dog actually poops out soft serve.",
  },
  {
    comicNumber: 42,
    date: "2021-11-26",
    comicTitle: "Jolly",
    titleText:
      "Am I a joyless Scrooge for ruining the enjoyment of people who want to celebrate early? Yes. Am I also a major proponent of strict delineation between holiday seasons? Also yes.",
  },
  {
    comicNumber: 43,
    date: "2021-12-03",
    comicTitle: "Imposter Syndrome",
    titleText:
      "And that dumb webcomic you make? No one really likes it. It's just bots upvoting it.",
  },
  {
    comicNumber: 44,
    date: "2021-12-10",
    comicTitle: "Content Creation",
    titleText:
      "It seems like it's the ones I'm not super enthusiastic about that always end up being popular.",
  },
  {
    comicNumber: 45,
    date: "2021-12-17",
    comicTitle: "Supply Chain",
    titleText:
      "Sorry reader, I couldn't think of a title text. Supply chain issues, y'know?",
  },
  {
    comicNumber: 46,
    date: "2021-12-24",
    comicTitle: "Christmas List",
    titleText:
      "This is even worse than last year, when my present was my heart, and less than 24 hours later you had already regifted it.",
  },
  {
    comicNumber: 47,
    date: "2021-12-31",
    comicTitle: "Doing Things",
    titleText:
      "But then how will I work myself up to be ready for it then be completely thrown off when it doesn't go as expected?",
  },
  {
    comicNumber: 48,
    date: "2022-01-07",
    comicTitle: "Cynical",
    titleText: "Later I'll look up tips on how to stop procrastinating.",
  },
  {
    comicNumber: 49,
    date: "2022-01-14",
    comicTitle: "Podcast",
    titleText: `"That's ridiculous. Do you really thing I would tell you if I was?"`,
  },
  {
    comicNumber: 50,
    date: "2022-01-28",
    comicTitle: "Charge and Drain",
    titleText:
      "Being introverted doesn't mean you hate being around people, it just means you only want to be around people for a certain amount of time.",
  },
  {
    comicNumber: 51,
    date: "2022-02-04",
    comicTitle: "Boba",
    titleText:
      "Yes, it's usually referred to as either boba or bubble tea, not boba tea. I'm a pedant myself. But Wikipedia has it as an acceptable term, so I'm going with it.",
  },
  {
    comicNumber: 52,
    date: "2022-02-11",
    comicTitle: "Sportsball",
    titleText:
      "Friendly reminder that hating things is not a personality trait.",
  },
  {
    comicNumber: 53,
    date: "2022-02-18",
    comicTitle: "Executive Dysfunction",
    titleText:
      "My psychologist says I can get an Adderal prescription once I see a physician, but for some reason I haven't gotten around to doing that.",
  },
  {
    comicNumber: 54,
    date: "2022-02-25",
    comicTitle: "Gassy",
    titleText:
      "I mean, sure there are other advantages to eating healthy, but I really thought that it would at least make me fart less.",
  },
  {
    comicNumber: 55,
    date: "2022-03-04",
    comicTitle: "Plants",
    titleText:
      "The sequel to this comic will feature her being suprised when our cat tries to eat them all.",
  },
  {
    comicNumber: 56,
    date: "2022-03-11",
    comicTitle: "Take a Walk",
    titleText:
      "The wind is blowing, the leaves are chirping, and I'm having an ongoing mental breakdown.",
  },
  {
    comicNumber: 57,
    date: "2022-03-25",
    comicTitle: "Office Job",
    titleText:
      "I haven't had anyone scold me over TPS reports, but if that ever happens I have my baseball bat ready.",
  },
  {
    comicNumber: 58,
    date: "2022-04-01",
    comicTitle: "sad lego man (April Fools)",
    titleText: "April fools!",
    className: "aprilFools",
  },
  {
    comicNumber: 59,
    date: "2022-04-08",
    comicTitle: "Cleaning",
    titleText:
      "No one may ever know the terrible secret that our house is not always in immaculate condtion.",
  },
  {
    comicNumber: 60,
    date: "2022-04-15",
    comicTitle: "Warrant",
    titleText: "I hereby sentence you to death by Poison.",
  },
  {
    comicNumber: 61,
    date: "2022-04-22",
    comicTitle: "Studies",
    titleText: "C's get degrees, regardless of how much alcohol you consume.",
  },
  {
    comicNumber: 62,
    date: "2022-04-29",
    comicTitle: "Microwave",
    titleText:
      "Why wait for properly cooked food when you can have kinda cooked food now?",
  },
  {
    comicNumber: 63,
    date: "2022-05-06",
    comicTitle: "Older Kid",
    titleText:
      "But he sure did have great advice on getting away with not doing your homework.",
  },
  {
    comicNumber: 64,
    date: "2022-05-20",
    comicTitle: "Hair",
    titleText:
      "No no, it looks great! Definitely worth the $250 you paid for it!",
  },
  {
    comicNumber: 65,
    date: "2022-05-27",
    comicTitle: "Relax",
    titleText: "Existential dread can wait until Monday!",
  },
  {
    comicNumber: 66,
    date: "2022-06-03",
    comicTitle: "Deep in Thought",
    titleText:
      "She definitely doesn't need to know it's also mashed up with the Full House theme.",
  },
  {
    comicNumber: 67,
    date: "2022-06-10",
    comicTitle: "Vacation Money",
    titleText: "But there's street parking right over there!",
  },
  {
    comicNumber: 68,
    date: "2022-06-17",
    comicTitle: "Every Summer",
    titleText:
      "Is 95 really that much hotter than 85? I'll let you know when my skin stops melting off.",
  },
  {
    comicNumber: 69,
    date: "2022-06-24",
    comicTitle: "Crippling",
    titleText: "Turns out that answer was drugs. Who knew?",
  },
  {
    comicNumber: 70,
    date: "2022-07-01",
    comicTitle: "News",
    titleText: "I don't even have anything funny to put here. I'm so tired.",
  },
  {
    comicNumber: 71,
    date: "2022-07-15",
    comicTitle: "Work from Home",
    titleText:
      "Lock them out of the office? They just cry at the door the whole time.",
  },
  {
    comicNumber: 72,
    date: "2022-07-29",
    comicTitle: "Dating Show",
    titleText:
      "Real talk: watching crappy dating shows is a great way for new couples to learn a lot about what each other expect in relationships.",
  },
  {
    comicNumber: 73,
    date: "2022-08-05",
    comicTitle: "Construction",
    titleText:
      "Is there a shortage of housing in this country? But the answer is not more unaforable condos.",
  },
  {
    comicNumber: 74,
    date: "2022-08-12",
    comicTitle: "Little Voice",
    titleText:
      "I miss the other guy who always told me I was the greatest person in the world and I could do no wrong.",
  },
  {
    comicNumber: 75,
    date: "2022-08-19",
    comicTitle: "Soup",
    titleText:
      "This joke has been percolating in my head looking for an outlet for at least 20 years.",
  },
  {
    comicNumber: 76,
    date: "2022-08-26",
    comicTitle: "Mirror",
    titleText:
      "Oh man, do other people have thoughts too? What is this crzy world?",
  },
  {
    comicNumber: 77,
    date: "2022-09-02",
    comicTitle: "Stop It",
    titleText: "Alright, that's it. We're gonna cuddle right now, no arguing!",
  },
  {
    comicNumber: 78,
    date: "2022-09-09",
    comicTitle: "Big Raise",
    titleText: "Just kidding, I never got a big raise in my twenties.",
  },
  {
    comicNumber: 79,
    date: "2022-09-16",
    comicTitle: "Find My Phone",
    titleText: "I don't even know how to get to that dimension!",
  },
  {
    comicNumber: 80,
    date: "2022-09-23",
    comicTitle: "Video Call",
    titleText: "Wait a minute, Alex is frozen.",
  },
  {
    comicNumber: 81,
    date: "2022-09-30",
    comicTitle: "Chilly",
    titleText: "Now to spend the next five months cuddled up under a blanket.",
  },
  {
    comicNumber: 82,
    date: "2022-10-07",
    comicTitle: "Sigh",
    titleText: "*sigh* I wish I didn't sigh so much.",
  },
  {
    comicNumber: 83,
    date: "2022-10-21",
    comicTitle: "Hotel",
    titleText: `"Now be quiet, some of us are tying to sleep here."`,
  },
  {
    comicNumber: 84,
    date: "2022-10-28",
    comicTitle: "Costumes",
    titleText: "So you don't want to be Fry and Zoidberg next year?",
  },
  {
    comicNumber: 85,
    date: "2022-11-04",
    comicTitle: "Social Media",
    titleText: "Follow us on Facebook, Instagram, or Twitter!",
  },
  {
    comicNumber: 86,
    date: "2022-11-11",
    comicTitle: "Lyrics",
    titleText: `My personal favorite for this is "Last Christmas", but that's not seasonably appropriate.`,
  },
  {
    comicNumber: 87,
    date: "2022-11-18",
    comicTitle: "Just Remembered",
    titleText: "...uh...I forgot what it was.",
  },
  {
    comicNumber: 88,
    date: "2022-11-25",
    comicTitle: "Family Gathering",
    titleText:
      "Last year my cousin's kid thought it was awesome that my favorite Pokémon was Charizard, so I'm going with yes.",
  },
  {
    comicNumber: 89,
    date: "2022-12-02",
    comicTitle: "Soccer",
    titleText:
      "Then as soon as we get eliminated, I pay zero attention to soccer for the next four years.",
  },
  {
    comicNumber: 90,
    date: "2022-12-09",
    comicTitle: "Space Suit",
    titleText:
      "If you don't like Space Laundry, you're gonna hate Space Dishes.",
  },
  {
    comicNumber: 91,
    date: "2022-12-16",
    comicTitle: "App",
    titleText:
      "Also I might have to change the arrangement of the icons on my home screen, and that will just totally screw up my muscle memory.",
  },
  {
    comicNumber: 92,
    date: "2022-12-23",
    comicTitle: "Christmas Wish",
    titleText: "Boy, this year sure flew by, huh?",
  },
  {
    comicNumber: 93,
    date: "2023-01-06",
    comicTitle: "Forty",
    titleText: "At my fifth consecutive thirtieth birthday party, duh.",
  },
  {
    comicNumber: 94,
    date: "2023-01-13",
    comicTitle: "Guitar",
    titleText: `Welp, I've strummed the chords to "Let It Be". Don't know what else there is to do.`,
  },
  {
    comicNumber: 95,
    date: "2023-01-20",
    comicTitle: "Cat Person",
    titleText: "Sure, they probably just want food, but I'll take it.",
  },
  {
    comicNumber: 96,
    date: "2023-02-03",
    comicTitle: "Bug",
    titleText:
      "I don't think I could claim submitting the wrong order could be a feature.",
  },
  {
    comicNumber: 97,
    date: "2023-02-10",
    comicTitle: "Time Travel",
    titleText:
      "Oh, and the White Sox win the World Series this year. Yeah, weird I know. I don't know how to gamble, but if you can figure that out...",
  },
  {
    comicNumber: 98,
    date: "2023-02-24",
    comicTitle: "Benjamin",
    titleText: '"Call me when you have two consecutive Grover Clevelands.',
  },
  {
    comicNumber: 99,
    date: "2023-03-03",
    comicTitle: "Big",
    titleText: "Okay buddy, time to trim your nails!",
  },
  {
    comicNumber: 100,
    date: "2023-03-10",
    comicTitle: "Outside",
    titleText:
      "I'm not saying I didn't have this issue before COVID broke out, but it definitely didn't help.",
  },
  {
    comicNumber: 101,
    date: "2023-03-17",
    comicTitle: "Coast is Clear",
    titleText: "It was the cat.",
  },
  {
    comicNumber: 102,
    date: "2023-03-24",
    comicTitle: "Organized",
    titleText:
      "No problem, when we clean the living room, we can just put stuff in the bedroom.",
  },
  {
    comicNumber: 103,
    date: "2023-04-07",
    comicTitle: "Domesticated",
    titleText:
      "This is an exaggeration, of course. Normally they just slowly tap roaches to death.",
  },
  {
    comicNumber: 104,
    date: "2023-04-14",
    comicTitle: "Pedantic",
    titleText: "Akshually, pedantic actually means...hey, where are you going?",
  },
  {
    comicNumber: 105,
    date: "2023-04-21",
    comicTitle: "Background",
    titleText: "Don't worry, his fight against Glup Shitto will be legendary!",
  },
  {
    comicNumber: 106,
    date: "2023-04-28",
    comicTitle: "Kitchen",
    titleText:
      "Or I could just order pizza again. That box was from like a week ago.",
  },
  {
    comicNumber: 107,
    date: "2023-06-02",
    comicTitle: "Same As It Ever Was",
    titleText:
      "According to famed oceanographer David Byrne, there is in fact water at the bottom of the ocean.",
  },
  {
    comicNumber: 108,
    date: "2023-06-09",
    comicTitle: "Scheduled",
    titleText:
      "Some will say when I started drinking coffee every day at 8:18 AM, but I choose to believe it was when I reached a certain age.",
  },
  {
    comicNumber: 109,
    date: "2023-06-16",
    comicTitle: "Compliments",
    titleText:
      "I'm sorry, I tuned out after you said I was handsome. You said something about a zeppelin?",
  },
  {
    comicNumber: 110,
    date: "2023-06-23",
    comicTitle: "Interview",
    titleText:
      "And I never imagined anyone would actually look at the mouseover text I make for every comic on the website!",
  },
  {
    comicNumber: 111,
    date: "2023-07-14",
    comicTitle: "Sober",
    titleText: "Wait, why do we even have words for noses and fingers?",
  },
  {
    comicNumber: 112,
    date: "2023-07-21",
    comicTitle: "Trash",
    titleText: "Maybe I feel a little down in the dumps.",
  },
  {
    comicNumber: 113,
    date: "2023-07-28",
    comicTitle: "Hot Dog",
    titleText:
      "The concept of a hot dog is always more appealing to me than the actual eating of one.",
  },
  {
    comicNumber: 114,
    date: "2023-08-11",
    comicTitle: "In the Way",
    titleText: "Excuse me, gotta write the title text.",
  },
  {
    comicNumber: 115,
    date: "2023-08-25",
    comicTitle: "After Work",
    titleText: "What, I'm supposed to just hang out with other people?",
  },
  {
    comicNumber: 116,
    date: "2023-09-08",
    comicTitle: "Coffee",
    titleText:
      "I tried setting the time to have it ready in the morning, but I set it for 8 PM instead of AM.",
  },
  {
    comicNumber: 117,
    date: "2023-09-22",
    comicTitle: "Out of Town",
    titleText:
      "I've also assembled a couple of LEGO sets this week. Amazing what you can do when you don't have to pay attention to another person.",
  },
  {
    comicNumber: 118,
    date: "2023-10-06",
    comicTitle: "Personality",
    titleText: "Ooh, do you want to hear about their health issue?",
  },
  {
    comicNumber: 119,
    date: "2023-10-13",
    comicTitle: "Vegetable",
    titleText: "Why does my heart hurt?",
  },
  {
    comicNumber: 120,
    date: "2023-10-20",
    comicTitle: "Debt",
    titleText: "You can do so many fun things with ramen.",
  },
  {
    comicNumber: 121,
    date: "2023-11-03",
    comicTitle: "Train",
    titleText:
      "There are also reports he is currently chewing on streetlights and knocking over people on bikes.",
  },
  {
    comicNumber: 122,
    date: "2023-11-10",
    comicTitle: "Rough",
    titleText:
      "It's all been downhill since we stopped turning our cameras off for video calls.",
  },
  {
    comicNumber: 123,
    date: "2023-11-17",
    comicTitle: "Startle",
    titleText:
      "To be fair, who could possibly expect another person in the house you share with your spouse?",
  },
  {
    comicNumber: 124,
    date: "2024-01-26",
    comicTitle: "Spilled",
    titleText: "Yeah, I'm fine. Why do you ask?",
  },
  {
    comicNumber: 125,
    date: "2024-02-09",
    comicTitle: "Ten Years",
    titleText:
      "Also five years since the Second Part. Somehow that feels right.",
  },
  {
    comicNumber: 126,
    date: "2024-02-23",
    comicTitle: "Stuff",
    titleText:
      "For the 5 people who actually go to the website and read the title text, yes I did go almost a month without putting this on the website.",
  },
  {
    comicNumber: 127,
    date: "2024-03-22",
    comicTitle: "Nook",
    titleText:
      "Why am I making jokes about Animal Crossing four years after it came out? Because that's how long it took LEGO to make sets from it and my medium is very restrictive in that way.",
  },
  {
    comicNumber: 128,
    date: "2024-05-17",
    comicTitle: "Outlet",
    titleText:
      "People love comics about not being able to think of comic ideas. Super relateable.",
  },
  {
    comicNumber: 129,
    date: "2024-06-21",
    comicTitle: "Friends",
    titleText: `Obviously I know when they said "We need to hang out soon" they actually meant "You're a terrible person and I never want to see you again"`,
  },
  {
    comicNumber: 130,
    date: "2024-09-20",
    comicTitle: "Flown By",
    titleText:
      "Still doesn't explain all the Christmas decorations going up in the stores.",
  },
  {
    comicNumber: 131,
    date: "2024-12-06",
    comicTitle: "Dollar Bill",
    titleText: "Now if you'll excuse me, I'm, going to go buy a $37 coffee.",
  },
  {
    comicNumber: 132,
    date: "2025-01-31",
    comicTitle: "Noises",
    titleText:
      "You always think you're crying wolf until an actual wolf shows up in your kitchen.",
  },
  {
    comicNumber: 133,
    date: "2025-02-14",
    comicTitle: "Meetup",
    titleText:
      "Some people didn't have unlimited texting in high school and it shows.",
  },
  {
    comicNumber: 134,
    date: "2025-05-15",
    comicTitle: "Parrot",
    titleText:
      "As a large language model, I am unable to create a title text for this comic.",
  },
  {
    comicNumber: 135,
    date: "2025-08-01",
    comicTitle: "Rectangle",
    titleText:
      "It was really nice there having a couple years where I didn't wake up with existential dread every morning.",
  },
  {
    comicNumber: 136,
    date: "2026-07-16",
    comicTitle: "Casual",
    titleText:
      "Apologies for the lack of posts for almost a year. And yes, I am tired.",
  },
  {
    comicNumber: 137,
    date: "2026-07-23",
    comicTitle: "Milk",
    titleText: "To be clear, I am not anti-latte, I am pro-defamiliarization",
  },
];
